<template lang="pug">
  include ./../../mixins
  +b.order
    +b.H2.caption.--size_2 {{ _("Create the order") }}
    +e.content
      validation-observer(
        tag="form"
        ref="observer"
        v-slot="props"
        @submit.prevent="validateBeforeSubmit"
      )
        +b.ug-row.--offset_sm
          +b.ug-cell.ug-cols.--6-sm.--4-lg
            validation-provider(
              tag="div"
              v-slot="{errors}"
              rules="required"
              name="date_at"
            )
              +b.control
                +e.elements
                  +b.FLAT-PICKER.control-input(
                    value='',
                    placeholder="",
                    name='date_at',
                    type="date",
                    v-model='formdata.date_at',
                    :config="configDate",
                    :class="{'flatpickr-input is-error': errors[0] }"
                  )
                  +e.label(:class='{"is-active": formdata.date_at}')
                    label {{ _("Date") }}
                +e.meta(v-if="errors[0]")
                  +e.help
                    +b.SPAN.help.--type_error(:class="{'is-error': errors[0]}") {{ errors[0] }}
          +b.ug-cell.ug-cols.--6-sm.--4-lg
            validation-provider(
              tag="div"
              v-slot="{errors}"
              rules="required"
              name="time"
            )
              +b.control
                +e.elements
                  +b.FLAT-PICKER.control-input(
                    value='',
                    placeholder="",
                    name='time',
                    type="time",
                    v-model='formdata.time',
                    :config="configTime",
                    :class="{'flatpickr-input is-error': errors[0] }"
                  )
                  +e.label(:class='{"is-active": formdata.time}')
                    label {{ _("Time") }}
                +e.meta(v-if="errors[0]")
                  +e.help
                    +b.SPAN.help.--type_error(:class="{'is-error': errors[0]}") {{ errors[0] }}
          +b.ug-cell.ug-cols.--6-sm.--4-lg
            validation-provider(
              tag="div"
              v-slot="{errors}"
              rules="required"
              name="price"
            )
              ui-input(
                v-model='formdata.price',
                type='text',
                :errors="errors"
                :label='_("Price")'
              )
          +b.ug-cell.ug-cols.--6-sm.--4-lg
            validation-provider(
              tag="div"
              v-slot="{errors}"
              rules="required"
              name="prepayment"
            )
              ui-input(
                v-model='formdata.prepayment',
                type='text',
                :errors="errors"
                :label='_("Prepayment")'
              )
          +b.ug-cell.ug-cols.--6-sm.--4-lg
            validation-provider(
              tag="div"
              v-slot="{errors}"
              rules="required"
              name="responsible"
            )
              +b.control
                +e.elements
                  multiselect(
                    :options="employees",
                    label='name',
                    placeholder=""
                    open-direction="bottom"
                    v-model="formdata.responsible"
                    :searchable="false",
                    :class="{'is-error': errors[0]}"
                    :show-labels="false"
                  )
                    template(slot='caret')
                      +e.icon
                        +b.I.icon.--type_dropdown
                  +e.label(
                    :class='{"is-active": formdata.responsible}'
                    
                  )
                    label {{ _("Responsible") }}
                +e.meta(v-if="errors[0]")
                  +e.help
                    +b.SPAN.help.--type_error(:class='{"is-error": errors[0]}') {{ errors[0] }}
          +b.ug-cell.ug-cols.--6-sm.--4-lg
            validation-provider(
              tag="div"
              v-slot="{errors}"
              rules="required"
              name="service"
            )
              +b.control
                +e.elements
                  multiselect(
                    :options="services",
                    label='title',
                    placeholder=""
                    open-direction="bottom"
                    v-model="formdata.service"
                    :searchable="false",
                    :class="{'is-error': errors[0]}"
                    :show-labels="false"
                  )
                    template(slot='caret')
                      +e.icon
                        +b.I.icon.--type_dropdown
                  +e.label(
                    :class='{"is-active": formdata.service}'
                    
                  )
                    label {{ _("Services") }}
                +e.meta(v-if="errors[0]")
                  +e.help
                    +b.SPAN.help.--type_error(:class='{"is-error": errors[0]}') {{ errors[0] }}
          +b.ug-cell.ug-cols
            validation-provider(
              tag="div"
              v-slot="{errors}"
              :rules="{max: 250}"
              name="comment"
            )
              +b.control
                +e.elements
                  +b.control-input.--textarea
                    +b.TEXTAREA.control-textarea(
                      v-model='formdata.comment',
                      name='comment',
                    )
                  +e.label(:class= "{'is-active': formdata.comment.length > 0}")
                    label {{ _("Comment") }}
                +e.meta(v-if="errors[0]")
                  +e.help
                    +b.SPAN.help.--type_error(:class="{'is-error': errors[0]}") {{ errors[0] }}
          +b.ug-cell.ug-cols
            +b.ug-row.--offset_sm.--justification_flexend
              +b.ug-cell.ug-cols.--6-sm
                +b.A.button(@click.prevent="validateBeforeSubmit") {{ _("Generate order") }}
</template>
<script>
import mixinValidate from '@/js/mixins/formValidate'
import mixinErrors from '@/js/mixins/showErrors'
export default {
  props: {
    url: String,
    employeesListUrl: String,
    servicesListUrl: String,
  },
  mixins: [
    mixinValidate,
    mixinErrors,
  ],
  data() {
    return {
      configDate: {
        dateFormat: "Y-m-d",
        minDate: "today",
      },
      configTime: {
        dateFormat: "H:i",
        enableTime: true,
        noCalendar: true,
        minDate: "today",
        'time_24hr': true
      },
      formdata: {
        comment: '',
        responsible: '',
        service: '',
      },
      employees: [],
      services: []
    }
  },
  mounted() {
    this.getEmployeesList()
    this.getServicesList()
  },
  methods: {
    getEmployeesList() {
      this.api.get(this.employeesListUrl).then(res => {
        let {data} = res
        this.employees = data
      })
    },
    getServicesList() {
      this.api.get(this.servicesListUrl).then(res => {
        let {data} = res
        this.services = data
      })
    },
    send() {
      let formdata = Object.assign({}, this.formdata)
      let prettyDate = `${formdata['date_at']} ${formdata['time']} GMT+0000`.replace(/-/g, "/")
      formdata['date_at'] = new Date(Date.parse(prettyDate)).toISOString()
      Object.keys(formdata).forEach(key => {
        if (formdata[key].hasOwnProperty('id')) {
          formdata[key] = formdata[key].id
        }
      })
      this.api.post(this.url, formdata).then(res => {
        let {data} = res
        if (data.link) {
          this.$emit('order-created', data.link)
        }
      }).catch(error => {
        let {data} = error.response
        this.showErrors(data)
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Order/OrderCreating.vue